import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import TrialDetailsContent from './TrialDetailsContent';
import { useRouter } from 'next/router';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const TrialDetails = (props: ComponentProps): JSX.Element => {
  const JssTrialTitle = () => (
    <Placeholder name="jss-trial-title" rendering={props.rendering} disableSuspense={true} />
  );
  const JssTrialLeft = () => (
    <Placeholder name="jss-trial-left" rendering={props.rendering} disableSuspense={true} />
  );
  const JssTrialRight = () => (
    <Placeholder name="jss-trial-right" rendering={props.rendering} disableSuspense={true} />
  );
  const router = useRouter();

  return (
    <>
      {!router.isReady && (
        <Backdrop open={true} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <TrialDetailsContent
        JssTrialLeft={JssTrialLeft}
        JssTrialRight={JssTrialRight}
        JssTrialTitle={JssTrialTitle}
      />
    </>
  );
};

export default TrialDetails;
